import "./ContactContainer.css";
import Icon from "../../../../components/elements/Icons/Icon";
import background from "../../../../images/contact_image.png";

const details = [
    {
        icon: "adres",
        title: "Adres",
        content: <span>ul. Kiepury 5B</span>,
    },
    {
        icon: "email",
        title: "E-mail",
        content: <a href="mailto:biuro@quena.pl">biuro@quena.pl</a>,
    },
    {
        icon: "contact_phone",
        title: "Telefon",
        content: (
            <span className="contact-phone-list">
                <a href="tel:+48817211965">+48 81 721-19-65</a>
                <a href="tel:+48607997416">+48 60 799-74-16</a>
            </span>
        ),
    },
];

export default function ContactContainer() {
    return (
        <section className="contact-container" aria-label="Dane kontaktowe Quena">
            <div className="contact-bg">
                <img src={background} alt="" aria-hidden="true" />
            </div>

            <div className="contact-content">
                <div className="contact-heading">
                    <h1>Quena</h1>
                </div>

                <div className="contact-bottom-container">
                    {details.map((detail, index) => (
                        <div className="contact-detail-wrap" key={detail.title}>
                            <div className="contact-date-block">
                                <div className="contact-date-icon-block" aria-hidden="true">
                                    <Icon name={detail.icon} color={"#6A542F"} />
                                </div>
                                <div className="contact-date-block-text">
                                    <h3 className="contact-bottom-container-title">{detail.title}</h3>
                                    <div className="contact-bottom-container-information">{detail.content}</div>
                                </div>
                            </div>
                            {index < details.length - 1 && <div className="contact-horizontal-line" />}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
